<template>
  <div class="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-40">
    <div class="bg-white rounded-xl shadow-2xl w-full max-w-2xl p-8 max-h-[90vh] overflow-y-auto">
      <div class="flex justify-between items-center mb-6">
        <h2 class="text-2xl font-bold text-gray-800">
          Zugangscodes hinzufügen
        </h2>
        <button @click="$emit('close')" class="text-gray-700 hover:text-black text-3xl admin-button--ghost admin-button--icon" aria-label="Schließen" title="Schließen">
          <i class="fa fa-xmark"></i>
        </button>
      </div>

      <div class="space-y-4">
        <div class="p-4 bg-blue-50 border border-blue-200 rounded">
          <h3 class="font-semibold mb-2">Zuordnung:</h3>
          <div class="text-sm text-gray-700">
            <p><strong>Einsatzstelle:</strong> {{ context.einsatzstelle_name }}</p>
            <p class="text-xs text-gray-500">Code: {{ context.einsatzstelle_code }}</p>
          </div>
        </div>

        <div>
          <label class="block text-sm font-semibold mb-2">
            Codes eingeben (ein Code pro Zeile):
          </label>
          <textarea 
            v-model="codesText" 
            class="border rounded px-3 py-2 w-full font-mono"
            rows="15"
            placeholder="1234&#10;5678&#10;9012&#10;..."
          ></textarea>
          <p class="text-sm text-gray-500 mt-1">
            {{ codeCount }} Code(s) werden hinzugefügt
          </p>
        </div>

        <div v-if="errorMessage" class="p-3 bg-red-100 border border-red-400 text-red-700 rounded">
          {{ errorMessage }}
        </div>

        <div v-if="successMessage" class="p-3 bg-green-100 border border-green-400 text-green-700 rounded">
          {{ successMessage }}
        </div>
      </div>

      <div class="flex justify-end gap-3 mt-6">
        <button 
          @click="$emit('close')" 
          class="px-4 py-2 bg-gray-300 text-gray-800 rounded hover:bg-gray-400 font-semibold admin-button--secondary">
          Abbrechen
        </button>
        <button 
          @click="save" 
          :disabled="codeCount === 0"
          class="px-4 py-2 bg-green-600 text-white rounded hover:bg-green-700 font-semibold disabled:opacity-50 disabled:cursor-not-allowed admin-button--primary">
          <i class="fa fa-check mr-2"></i>{{ codeCount }} Code(s) hinzufügen
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import CASP from "../CASP";

export default {
  name: 'AccessCodeBulkModal',
  props: {
    context: {
      type: Object,
      required: true
    }
  },
  emits: ['close', 'save'],
  data() {
    return {
      codesText: '',
      errorMessage: '',
      successMessage: ''
    };
  },
  computed: {
    codeCount() {
      const codes = this.codesText.split('\n').filter(c => c.trim());
      return codes.length;
    }
  },
  methods: {
    save() {
      const codes = this.codesText.split('\n').filter(c => c.trim());
      
      if (codes.length === 0) {
        this.errorMessage = 'Bitte mindestens einen Code eingeben';
        return;
      }

      this.errorMessage = '';
      this.successMessage = '';
      document.getElementById("mainspinner").style.display = "inline-block";

      const payload = {
        codes: codes,
        einsatzstelle_code: this.context.einsatzstelle_code
      };

      CASP.createAccessCode(payload, (status, response) => {
        document.getElementById("mainspinner").style.display = "none";
        if (status === 200 || status === 201) {
          this.successMessage = `${codes.length} Code(s) erfolgreich hinzugefügt`;
          setTimeout(() => {
            this.$emit('save', response);
            this.$emit('close');
          }, 1000);
        } else {
          this.errorMessage = 'Fehler beim Hinzufügen der Codes';
        }
      });
    }
  }
};
</script>

<style scoped>
</style>
